"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliverySchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const deliveryTypeArray = ['twilio', 'whatsapp'];
const deliveryType = [...deliveryTypeArray];
exports.deliverySchema = yup_lib_1.default.object().shape({
    type: yup_lib_1.default.string().oneOf(deliveryTypeArray).required(),
    meta: yup_lib_1.default.object().required('Meta information required for Delivery')
});
